module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dialogTitle":"Edit club","clubsActionsEditOneSuccess":"%{clubsName} was successfully updated in the database"},"no":{"dialogTitle":"Rediger klubb","clubsActionsEditOneSuccess":"%{clubsName} ble redigert i databasen"}}')
  delete Component.options._Ctor
}
